'use client';

import React from 'react';
import { Scale, TrendingUp, Target, Activity, BarChart2, Zap } from 'lucide-react';
import { FLOCK_GROWTH_SUMMARIES } from './growthData';
import { StatCard } from '@/components/ui/Cards';


export default function GrowthSummaryCards() {
  const summaries = FLOCK_GROWTH_SUMMARIES;
  const totalFlocks = summaries?.length;
  const onTrack = summaries?.filter(s => s?.status === 'on_track' || s?.status === 'above_target')?.length;
  const belowTarget = summaries?.filter(s => s?.status === 'below_target')?.length;
  const avgUniformity = summaries?.reduce((s, f) => s + f?.latestUniformityPct, 0) / totalFlocks;
  const avgFcr = summaries?.reduce((s, f) => s + f?.latestFcr, 0) / totalFlocks;
  const avgAdg = summaries?.reduce((s, f) => s + f?.latestAdg, 0) / totalFlocks;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 mb-5">
      <StatCard label="Active Flocks Tracked" value={totalFlocks} sub="With weight records" icon={Scale} iconBg="#eff6ff" iconColor="#2563eb" />
      <StatCard label="On / Above Target" value={onTrack} sub={`${Math.round((onTrack / totalFlocks) * 100)}% of flocks`} icon={Target} iconBg="#f0fdf4" iconColor="#15803d" />
      <StatCard label="Below Target" value={belowTarget} sub="Need attention" icon={TrendingUp} iconBg="#fffbeb" iconColor="#d97706" alert={belowTarget > 0} alertVariant="warning" />
      <StatCard label="Avg Uniformity" value={`${avgUniformity?.toFixed(1)}%`} sub="All flocks combined" icon={Activity} iconBg="#faf5ff" iconColor="#7c3aed" />
      <StatCard label="Avg FCR" value={avgFcr?.toFixed(2)} sub="Feed conversion ratio" icon={BarChart2} iconBg="#f0fdfa" iconColor="#0f766e" />
      <StatCard label="Avg Daily Gain" value={`${avgAdg?.toFixed(1)}g`} sub="Grams per bird/day" icon={Zap} iconBg="#fff7ed" iconColor="#c2410c" />
    </div>
  );
}
